export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-960-6ad36cb4062556bf0b0c17b1fc05ca67.png";